import React, { useMemo, useContext } from "react";
import { intl, LanguageBaseContext } from "dmsbasereact";
import { Chip, Box } from "@mui/material";
import { ReportLayout } from "./components/ReportLayout";
import { getInstitutionCategoryLabel } from "../../constants/InstitutionType";
import { formatDate } from "../../utils/formatters";

export const HomologatedClientsReportPage = () => {
    const { language } = useContext(LanguageBaseContext);

    // eslint-disable-next-line react-hooks/exhaustive-deps -- language is required for i18n updates
    const header = useMemo(() => [
        { label: intl.get("Name").d("Name"), column_name: "name", width: "200px" },
        { label: intl.get("CNPJ").d("CNPJ"), column_name: "cnpj", width: "160px" },
        {
            label: intl.get("Category").d("Category"),
            column_name: "categories",
            width: "200px",
            element: (row) => {
                const cats = Array.isArray(row.categories) && row.categories.length > 0
                    ? row.categories
                    : (row.category != null ? [row.category] : []);
                return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {cats.map((c) => (
                            <Chip key={c} size="small" variant="outlined" label={getInstitutionCategoryLabel(c)} />
                        ))}
                    </Box>
                );
            },
        },
        { label: intl.get("State").d("State"), column_name: "state", width: "60px" },
        { label: intl.get("City").d("City"), column_name: "city", width: "140px" },
        {
            label: intl.get("Reports.HomologatedClients.HomologatedAt").d("Homologated At"),
            column_name: "sap_homologated_at",
            width: "140px",
            function: (value) => (value && value !== "--") ? formatDate(value) : "--"
        },
    ], [language]);

    // eslint-disable-next-line react-hooks/exhaustive-deps -- language is required for i18n updates
    const filterFields = useMemo(() => [
        { name: "name", label: intl.get("Name").d("Name"), type: "text" },
        { name: "cnpj", label: intl.get("CNPJ").d("CNPJ"), type: "text" },
        { name: "category", label: intl.get("Category").d("Category"), type: "multiselect", optionsKey: "category" },
        { name: "state", label: intl.get("State").d("State"), type: "multiselect", optionsKey: "state" },
        { name: "city", label: intl.get("City").d("City"), type: "text" },
    ], [language]);

    return (
        <ReportLayout
            key={`homologated-clients-report-${language}`}
            title="Reports.Menu.DirectChannelClients"
            titleDefault="Direct Channel Clients Report"
            manualSlug="reports-homologated-clients"
            tableUrl="/reports/homologated-clients/table"
            filterOptionsUrl="/reports/homologated-clients/filter-options"
            exportUrl="/reports/homologated-clients/export"
            header={header}
            filterFields={filterFields}
            dateFilterLabel={intl.get("Reports.HomologatedClients.HomologatedAt").d("Homologated At")}
        />
    );
};

export default HomologatedClientsReportPage;
